import { getConsoleStyle as e } from "./styledLogs.js";
//#region src/utils/init/doNotUseTailwind.ts
var t = async () => {
	let e = document.querySelectorAll("link[rel=\"stylesheet\"]");
	for (let t of e) try {
		if ((await (await fetch(t.href)).text()).includes("--tw")) return !0;
	} catch (e) {
		console.warn(`Failed to fetch CSS file: ${t.href}`, e);
	}
	let t = document.querySelectorAll("style");
	for (let e of t) if (e.textContent?.includes("--tw")) return !0;
	return !1;
}, n = !1;
(async () => {
	try {
		n = await t();
	} catch (e) {
		console.error("Error during Tailwind detection:", e);
	}
})(), setInterval(() => {
	if (n) {
		let t = [
			"TAILWIND DETECTED!!!",
			"Using Tailwind CSS in combination with the RIO UIKIT is strongly discouraged because it can lead to significant design and development issues.",
			"The RIO UIKIT is a component-driven design system with carefully crafted styles to ensure consistent branding and user experience.",
			"Tailwind CSS, as a utility-first framework, introduces inline styling that can conflict with the RIO UIKIT’s predefined component styles.",
			"This can result in overridden styles, broken layouts, inconsistent spacings, inconsistent design language, and increased maintenance complexity.",
			"Tailwind’s global reset styles may also disrupt the base styles of the RIO UIKIT, causing unintended visual changes.",
			"Furthermore, mixing the two systems creates unnecessary redundancy, increases CSS bundle size, and complicates debugging and future updates.",
			"To ensure a cohesive, maintainable, and professional design system, it is essential to rely solely on the RIO UIKIT and its customization options rather than introducing conflicting styling frameworks.",
			"WE MAY TECHNICALLY DISABLE TAILWIND FUNCTIONALITY IN THE FUTURE.\nPLEASE DO NOT USE TAILWIND!"
		].join("\n\n");
		console.warn("%c%s", e(), t);
	}
}, 1e4);
//#endregion
export { t as doNotUseTailwind };

//# sourceMappingURL=doNotUseTailwind.js.map